import React from "react";
import { Link } from "react-router-dom";

export default function Section2() {
  return (
    <div className="w-full Section2">
      <div className="container-1280 section2-container w-[90%] md:w-[95%] xl:w-[100%] pt-[60px] mx-auto flex flex-col md:flex-row">
        <div className="image-container w-full md:w-[70%] sxl:w-[50%] h-auto md:h-[524px] m-auto">
          <img
            className="block object-contain w-auto h-full mx-auto md:w-full"
            src="/assets/section2-aboutus.webp"
            alt="CEO Image"
          ></img>
        </div>
        <div className="w-full text-center md:text-left pt-[70px] md:w-[50%] md:pt-[34px]">
          <h2 className=" text-[26px] md:text-[34px] font-bold mb-5 md:mb-2">About Us</h2>
          <p className="pb-5 text-[16px] md:text-[14px] font-open text-[#373737] leading-normal">
            Founded in 2017 by Abdul Hadi Siraj, Mean3 is a leading software house and
            marketing agency specializing in driving business success while optimizing costs.
            Recognized as an Emerging Web Application Development Agency, Mean3 has
            partnered with over 300+ global businesses, supported by a talented in-house
            team of 100+ professionals across offices in New York, Pakistan, and Dubai. As
            official Shopify and Shopify Plus experts, the agency delivers top-tier e-commerce
            solutions for clients such as TCS, Habitt, Vital Tea, Hyundai, Carters, Maulana
            Tariq Jamil (MTJ), Diners, and renowned automobile brands like KIA, Hyundai, and
            PEUGEOT. Ranked among the top 15 global high-value agencies for digital
            transformation, Mean3 was invited to Shopify's New York headquarters and has
            earned accolades like the Fastest Growing Brand of the Year and the Go Global
            Award. Showcasing its innovation at international platforms including GITEX
            Global, TechCrunch, and Leap'24, Mean3 blends expertise with innovation to
            shape the future of global business, turning visionary ideas into reality.
          </p>
          <div className="mt-5 btn-container md:mt-0">
            <Link
              to="/contact-mean3"
            >
              <button className="py-2 px-[51px] font-bold bg-[#DA2128] text-white rounded-[3px] border-none">Reach us out</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="line my-[55px] md:my-[5%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
